import { UNIVERSAL_TABLE_DEFAULT_PAGINATION } from "./buildUniversalTableUrlSettings";

export const STRATEGY_DASHBOARD_PREVIEW_ROWS_PER_PAGE = 8;

/**
 * @typedef {Object} UniversalTablePagination
 * @property {number} [current=1]
 * @property {number} [rowsPerPage]
 */

/**
 * @param {UniversalTablePagination} [pagination={}]
 * @returns {UniversalTablePagination}
 */
export function mapStrategyPreviewPaginationToFullTable(pagination = {}) {
  const current = pagination.current || 1;
  const rowsPerPage = pagination.rowsPerPage;

  if (rowsPerPage !== STRATEGY_DASHBOARD_PREVIEW_ROWS_PER_PAGE) {
    return {
      current,
      rowsPerPage
    };
  }

  const targetRowsPerPage = UNIVERSAL_TABLE_DEFAULT_PAGINATION.rowsPerPage;
  const firstRowIndex = (current - 1) * STRATEGY_DASHBOARD_PREVIEW_ROWS_PER_PAGE;
  const mappedCurrent = Math.floor(firstRowIndex / targetRowsPerPage) + 1;

  return {
    current: mappedCurrent,
    rowsPerPage: targetRowsPerPage
  };
}
